<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('inactiveRequestSettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="botConfig['enableAutoMad']" v-on:change="updateEnableAutoMad" :false-value="'0'" :true-value="'1'">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('autoHandleInactiveRequest')|capitalize }}:
                                            <strong v-show="botConfig['enableAutoMad']==='1'" class="success--text">{{ $t('on')|capitalize }}</strong>
                                            <strong v-show="botConfig['enableAutoMad']!=='1'"  class="error--text">{{ $t('off')|capitalize }}</strong>
                                        </div>
                                    </template>
                                </v-switch>

                                <div style="display: flex">
                                    <v-text-field id="waiting-time-minutes-input"
                                                  class="form-control pt-0 mt-0 px-2"
                                                  v-model="botConfig['autoMadConfigs'].wait_time_minutes"
                                                  mask="###############"
                                                  v-on:change="updateAutoMadConfigs"
                                                  :rules="[formRules.ruleMin(1)]"
                                                  :suffix="$t('minute')"
                                                  :label="$t('autoMadWaitingTimeMinutes')">
                                    </v-text-field>
                                </div>

                                <div class="pt-2" v-for="auto_mad_case of case_list" :key="auto_mad_case.name">
                                    <div>{{ auto_mad_case.label }}:</div>
                                    <div class="pl-3 pr-2">
                                        <v-select
                                            :items="auto_mad_case.actions"
                                            :label="$t('action')|capitalize"
                                            v-model="botConfig['autoMadConfigs'][auto_mad_case.name].action"
                                            v-on:change="updateAutoMadConfigs"
                                        ></v-select>
                                        <v-textarea
                                            rows="2"
                                            outline
                                            :label="$t('notifyMessage')"
                                            v-model="botConfig['autoMadConfigs'][auto_mad_case.name].message"
                                            v-on:change="updateAutoMadConfigs"
                                            v-show="botConfig['autoMadConfigs'][auto_mad_case.name].action !== action_list.do_nothing.value"
                                        ></v-textarea>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    import BotService from "@/services/bot.service";
    import {mapMutations, mapState} from "vuex";
    import FormMixin from '@/mixins/FormMixin'

    export default {
        name: "AutoMadSetting",
        mixins: [FormMixin],
        props: {
            botCode: String,
        },
        computed: {
            ...mapState('config', ['botConfig'])
        },
        data() {
            const ACTION_LIST = {
                do_nothing: {text: this.$t('autoMadActionDoNothing'), value: 'do_nothing'},
                auto_mad: {text: this.$t('autoMadActionAutoMad'), value: 'auto_mad'},
                turn_on_bot: {text: this.$t('autoMadActionTurnOnBot'), value: 'turn_on_bot'},
                send_message: {text: this.$t('autoMadActionSendMessage'), value: 'send_message'},
            };
            return {
                loadingDialog: false,
                action_list: ACTION_LIST,
                case_list: [
                    {name: "case_unassigned", label: this.$t("autoMadCaseUnassigned"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.turn_on_bot, ACTION_LIST.send_message]},
                    {name: "case_last_message_from_agent", label: this.$t("autoMadCaseLastMessageAgent"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.send_message]},
                    {name: "case_last_message_from_user", label: this.$t("autoMadCaseLastMessageUser"),
                        actions: [ACTION_LIST.do_nothing, ACTION_LIST.auto_mad, ACTION_LIST.send_message]},
                ]
            }
        },
        methods: {
            ...mapMutations('config', ['setBotConfig']),
            updateEnableAutoMad() {
                this.loadingDialog = true;
                BotService.updateEnableAutoMad(this.botCode, this.botConfig['enableAutoMad'])
                    .then(()=> {
                        this.setBotConfig({enable_auto_mad: this.botConfig['enableAutoMad']});
                        this.$AppService.toastSuccess("Update config success.");
                }).catch(()=>{
                    this.$AppService.toastError("Update config failed");
                }).finally(() => {
                    this.loadingDialog = false;
                })
            },
            updateAutoMadConfigs() {
                this.loadingDialog = true;
                let wait_time = parseInt(this.botConfig['autoMadConfigs'].wait_time_minutes);
                if (!wait_time > 0) {
                    this.botConfig['autoMadConfigs'].wait_time_minutes = 1;
                }
                BotService.updateAutoMadConfigs(this.botCode, this.botConfig['autoMadConfigs'])
                    .then(()=> {
                        this.setBotConfig({auto_mad_configs: this.botConfig['autoMadConfigs']});
                        this.$AppService.toastSuccess("Update config success.");
                    }).catch(()=>{
                    this.$AppService.toastError("Update config failed");
                }).finally(() => {
                    this.loadingDialog = false;
                });
            }
        },
    }
</script>

<style scoped>
</style>

<style scoped lang="scss" src="../../components/style/chat-view.scss"></style>